import { render, staticRenderFns } from "./contentManagment.vue?vue&type=template&id=37a96501"
import script from "./contentManagment.vue?vue&type=script&lang=js"
export * from "./contentManagment.vue?vue&type=script&lang=js"
import style0 from "./contentManagment.vue?vue&type=style&index=0&id=37a96501&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports